import React from "react";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import Navigation from "../Navigation/Navigation";
import { Link, NavLink } from "react-router-dom";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { useState } from "react";
import { useEffect } from "react";
import MyProfileSubscriptionLock from "../MyProfileSubscriptionLock/MyProfileSubscriptionLock";

const MyProfileSubscriptionPageLock = () => {
  const [currentTab, setcurrentTab] = useState("");
  const path = window.location.href;
  const endPath = path.split("/");

  useEffect(() => {
    if (endPath[4] === "subscription") {
      setcurrentTab("subscription");
    }
  }, []);
  
  useEffect(() => {
    window.scrollTo(0, document.body.scrollHeight);
  }, []);
  return (
    <div className="lock_Screen_Subscription">
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to={"/dashboard"}>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>
          <p className="page-maintitle">My Profile</p>
          <div className="acc-dashboard mt-4">
            <div className="mb-2 tabs_ul">
              <NavLink to={"/my-profile/general-info"} className={"tabs_li"}>
                General Info
              </NavLink>
              <NavLink to={"/my-profile/business-info"} className={"tabs_li"}>
                Business Info
              </NavLink>
              <NavLink to={"/my-profile/store-info"} className={"tabs_li"}>
                Store Info
              </NavLink>
              <NavLink
                to={"/my-profile/subscription"}
                className={
                  currentTab === "subscription" ? " activeTab" : "tabs_li"
                }
              >
                Subscription
              </NavLink>
              {/* <NavLink to={"/my-profile/bank-info"} className={"tabs_li"}>
                Bank Info
              </NavLink> */}
              {/* <NavLink
                to={"/my-profile/transaction-history"}
                className={"tabs_li"}
              >
                Transaction History
              </NavLink> */}
              <NavLink
                to={"/my-profile/marketplace-membership"}
                className={"tabs_li"}
              >
                Marketplace Membership
              </NavLink>
            </div>

            <div className="mt-3">
              <MyProfileSubscriptionLock />
            </div>
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </div>
  );
};

export default MyProfileSubscriptionPageLock;
